/** @format */

import React from "react";
import { useTheme } from "@mui/material/styles";
import ReactApexcharts from "react-apexcharts";

function PopularityChart({ value, color }) {
  const theme = useTheme();

  const options = {
    chart: { sparkline: { enabled: true } },
    stroke: { width: 1, lineCap: "round" },
    colors: [color],
    plotOptions: {
      radialBar: {
        endAngle: 90,
        startAngle: -90,
        hollow: { size: "70%" },
        track: { strokeWidth: "80%" },
        dataLabels: {
          name: { show: false },
          value: {
            offsetY: -20,
            fontWeight: 600,
            color: "#008",
            formatter: (val) => `${val / 10}/10`,
            fontFamily: theme.typography.fontFamily,
            fontSize: "30px",
          },
        },
      },
    },
    grid: {
      padding: {
        bottom: 20, // Niche thodi space muki
      },
    },
  };

  return <ReactApexcharts type="radialBar" height={250} series={[value]} options={options} />;
}

export default PopularityChart;
